module.exports = __webpack_public_path__ + "static/media/mmm-icon-minus.9c610dda.svg";